import { useState, useEffect, useContext } from 'react'
import { useParams, Link } from 'react-router-dom'
import { isMobile } from 'react-device-detect';
import { BedethequeContext } from '../utils/context/bedetheque';
import { useAuthState } from '../utils/context/auth';
import { myConsoleLog } from '../libs/constantes'
import HeaderPage from '../components/headerPage';
import Album from '../components/molecules/Album';
import { handleAnchor } from '../libs/apiController';
import SerieLeftTips from '../components/molecules/SerieLeftTips';
import SerieRightNavigation from '../components/molecules/SerieRightNavigation';
import '../utils/style/serie.css';


function Serie() {
    const { bedetheque } = useContext(BedethequeContext);
    const { userPrefs } = useAuthState();
    const { serieId } = useParams()
    const [sSerie, setSserie] = useState(null)
    const [currentAlbumId, setCurrentAlbumId] = useState(null)

    // Scroll initial (haut de page ou ancre) — uniquement à l'arrivée sur la série,
    // pas à chaque édition. Sinon le refetch déclenché par setReload rejouait le scroll.
    useEffect(() => {
        if(window.location.href.includes('#')) {
            setTimeout(() => {
                let hash = window.location.hash.substring(1);
                handleAnchor(`${hash}`)
                }, "100")
        } else {
            window.scrollTo(0, 0)
        }
    }, [serieId])

    // Resynchronise à chaque rafraîchissement de `bedetheque` (ex: après setReload
    // suite à une édition) — sans le garde `!sSerie` qui figeait la page sur les
    // premières données et imposait un refresh manuel.
    useEffect(() => {
        if(serieId) {
            let serieFromCtxt = bedetheque.filter((el) => el.idserie === parseInt(serieId))
            if(serieFromCtxt.length) {
                setSserie(serieFromCtxt)
                myConsoleLog('/serie/' + serieId , serieFromCtxt)
            }
        }
    }, [bedetheque, serieId])

    // Scrollspy : met en évidence la miniature de droite correspondant à l'album le plus visible.
    useEffect(() => {
        if (isMobile || !sSerie || sSerie.length <= 1) return
        const ratios = new Map()
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    ratios.set(entry.target.id, entry.intersectionRatio)
                })
                let maxRatio = 0
                let maxId = null
                ratios.forEach((ratio, id) => {
                    if (ratio > maxRatio) {
                        maxRatio = ratio
                        maxId = id
                    }
                })
                if (maxRatio > 0) setCurrentAlbumId(maxId)
            },
            { threshold: Array.from({ length: 11 }, (_, i) => i / 10) }
        )
        document.querySelectorAll('.albumContainer').forEach((el) => observer.observe(el))
        return () => observer.disconnect()
    }, [sSerie])

    if(!bedetheque || !sSerie || !serieId) return;
        
    const rightText = sSerie?.length > 1 ? sSerie?.length + ' albums' : sSerie?.length + ' album'
    
    return (
        <div>
        <HeaderPage leftText={sSerie[0]?.genre} centerText={sSerie[0]?.serie} rightText={rightText} edition={userPrefs?.editionMode} album={sSerie[0]}/>

        {/* En mobile, le panneau gauche du header (genre) est masqué : on réaffiche le genre
            en pastilles cliquables sous le header (lancent une recherche). */}
        {isMobile && sSerie[0]?.genre &&
            <div className="serie-genre-mobile">
                {(Array.isArray(sSerie[0].genre) ? sSerie[0].genre : [sSerie[0].genre]).map((g, i) => (
                    <Link className="serie-genre-tag" key={`${g}-${i}`} to={`../search/${g.includes('/') ? g.split('/')[0] : g}`}>{g}</Link>
                ))}
            </div>
        }

        <div className={isMobile ? "spaceContainerMobile" : "spaceContainer"}>
            
            <div className='left' style={{position: 'sticky', top : '146px'}}>
                {!isMobile &&
                    <SerieLeftTips serieId={serieId} serieContent={sSerie} />
                }
            </div>

            <div className="space">
                {sSerie?.map((album, index) => ( album &&
                    <div className="albumContainer" key={`${album._id}-${index}`} id={album._id}>
                        <Album edition={userPrefs?.editionMode} reqAlbum={album} />
                    </div>
                ))}

                {isMobile &&
                    <SerieLeftTips serieId={serieId} serieContent={sSerie} isMobile={true}/>
                }
            </div>

            <div className='right' style={{position: 'sticky', top : '146px'}}>
                {sSerie?.length > 1 && !isMobile && (
                    <SerieRightNavigation serieContent={sSerie} currentAlbumId={currentAlbumId}/>
                )}
            </div>
        
        </div>
    </div>
    )
}
 
export default Serie